import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import { countryLandings } from "../data/countryLandings";
import NarwhalMark from "./NarwhalMark";

const Footer = ({ onBook }) => {
  const { lang } = useLanguage();
  const t = content[lang].footer;
  const nav = content[lang].nav;
  const navigate = useNavigate();

  const handleLink = (e, link) => {
    if (link.href) {
      e.preventDefault();
      navigate(link.href);
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="relative border-t border-white/8 bg-narwhal-dark pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <NarwhalMark className="w-9 h-9" testId="footer-brand-image" />
              <span className="text-white font-semibold tracking-[0.18em] text-lg" data-testid="footer-brand-name">NARWHAL</span>
            </div>
            <p className="mt-5 text-sm text-narwhal-muted max-w-xs leading-relaxed" data-testid="footer-tagline">{t.tagline}</p>
            <button onClick={onBook} data-testid="footer-book-call-button" className="mt-6 inline-flex items-center rounded-md border border-narwhal-teal/50 px-4 py-2 text-sm text-white hover:bg-narwhal-teal hover:text-narwhal-dark transition-colors">
              {nav.cta}
            </button>
          </div>
          {t.cols.map((col, colIndex) => (
            <nav key={colIndex} aria-labelledby={`footer-column-${colIndex}-title`} data-testid={`footer-column-${colIndex}`}>
              <h4 id={`footer-column-${colIndex}-title`} className="text-white/90 font-medium text-sm" data-testid={`footer-column-title-${colIndex}`}>{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link, linkIndex) => (
                  <li key={link.id}>
                    <a href={link.href || `#${link.id}`} onClick={(e) => handleLink(e, link)} className="text-sm text-narwhal-muted hover:text-narwhal-teal transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-narwhal-teal" data-testid={`footer-link-${colIndex}-${linkIndex}`}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <nav aria-label="Mercados" className="mt-12 pt-8 border-t border-white/8" data-testid="footer-markets">
          <h4 className="text-white/90 font-medium text-sm">{lang === "en" ? "Markets" : "Mercados"}</h4>
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2.5">
            {countryLandings.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/${c.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-narwhal-muted hover:text-narwhal-teal transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-narwhal-teal"
                  data-testid={`footer-market-${c.slug}`}
                >
                  {c.country[lang] || c.country.es}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-xs text-white/40" data-testid="footer-copyright">© {new Date().getFullYear()} Narwhal. {t.rights}</span>
          <div className="flex items-center gap-2 text-xs text-white/40" data-testid="footer-regions">
            <span className="w-2 h-2 rounded-full bg-narwhal-teal animate-pulse motion-reduce:animate-none" aria-hidden="true" />
            {t.regions}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
